<template lang="pug">
.col-12
  .card
    .card-primary
      .card-header.text-primary.pl-4
        a.btn.btn-icon.btn-ticketlist-back(href="javascript:void(0)" @click="redirect()")
          i.fas.fa-arrow-left
        h4.ml-3
          span {{ $t("ui.member_linkage_detail") }}
    .card-header
      .row.w-100
        .form-group.col-12.col-xl-4
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.member') }}
            DebounceInput(type="text" size="sm" v-model="secondMemberName" disabled)
        .form-group.col-12.col-xl-4
          b-input-group(size="sm")
            b-input-group-text(slot="prepend")
              span {{ $t('ui.second_id') }}
            DebounceInput(type="text" size="sm" v-model="linkageDetail.target_id" disabled)
        .col-12.px-0
          .form-group.col-12.col-xl-3.mb-1
            b-input-group(size="sm")
              b-input-group-text(slot="prepend")
                span {{ $t('ui.linkage') }}
              LinkageOperatorLookup(
                size="sm"
                type="array"
                v-model="linkageType"
                :disabled="loading"
                :operatorID="operatorID"
                @input="getMemberLinkageDetail(true)"
              )
        .form-group.col-12.mb-1
          SubmitButton(
            icon="fa fa-search"
            :loading="loading"
            :text="$t('ui.search')"
            type="button"
            @click="getMemberLinkageDetail(true)"
            variant="primary"
            size="sm"
          ).mr-2

    .card-body
      .row
        .col-10.mb-1
          b-pagination.float-left(
            size="sm"
            hide-ellipsis
            :total-rows="totalRowDetail"
            :per-page="getPageSizeDetail"
            v-model="currentPageDetail"
            @input="changedPageDetail($event)")
        .col-2.mb-1
          b-input-group(:prepend="$t('ui.page_size')" size="sm")
            b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSizeDetail" @input="changedPageDetailSize" size="sm")
        .col-12(style="max-height: 70vh; overflow: hidden;")
          .clusterize-scroll.table-responsive
            table.table.table-sm.table-bordered.table-striped.table-hover#dsaList(style="width: 100%;")
              thead.thead-light
                tr
                  th.text-center(width="3%")
                    span #
                  th(width="10%" @click="sortOrder('linkage')")
                    span(:title="$t('ui.linkage')") {{ $t('ui.linkage') }}
                    .float-right
                      i(:class="changeSortKey('linkage')")
                  th(width="10%" @click="sortOrder('linkage_value')")
                    span(:title="$t('ui.linkage_value')") {{ $t('ui.linkage_value') }}
                    .float-right
                      i(:class="changeSortKey('linkage_value')")
                  th.text-center(width="10%" @click="sortOrder('source_occurrence_count')")
                    span(:title="$t('ui.source_occurrence_count')") {{ $t('ui.source_occurrence_count') }}
                    .float-right
                      i(:class="changeSortKey('source_occurrence_count')")
                  th.text-right(width="10%" @click="sortOrder('source_last_seen_at')")
                    span(:title="$t('ui.source_last_seen_at')") {{ $t('ui.source_last_seen_at') }}
                    .float-right
                      i(:class="changeSortKey('source_last_seen_at')")
                  th.text-center(width="10%" @click="sortOrder('target_occurrence_count')")
                    span(:title="$t('ui.target_occurrence_count')") {{ $t('ui.target_occurrence_count') }}
                    .float-right
                      i(:class="changeSortKey('target_occurrence_count')")
                  th.text-right(width="10%" @click="sortOrder('target_last_seen_at')")
                    span(:title="$t('ui.target_last_seen_at')") {{ $t('ui.target_last_seen_at') }}
                    .float-right
                      i(:class="changeSortKey('target_last_seen_at')")
              tbody.clusterize-content
                tr(v-if="memberLinkageDetailList.length == 0")
                  td(colspan="7").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in memberLinkageDetailList")
                  td.text-center
                    span(:title="((currentPageDetail - 1) * getPageSizeDetail + index + 1)") {{ ((currentPageDetail - 1) * getPageSizeDetail + index + 1) }}
                  td
                    span(:title="item.linkage") {{ item.linkage }}
                  td
                    span(:title="item.linkage_value") {{ item.linkage_value }}
                  td.text-center
                    span(:title="item.source_occurrence_count") {{ item.source_occurrence_count }}
                  td.text-right
                    span(:title="$moment(item.source_last_seen_at).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.source_last_seen_at") {{ $moment(item.source_last_seen_at).format('YYYY-MM-DD, HH:mm:ss') }}
                  td.text-center
                    span(:title="item.target_occurrence_count") {{ item.target_occurrence_count }}
                  td.text-right
                    span(:title="$moment(item.target_last_seen_at).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.target_last_seen_at") {{ $moment(item.target_last_seen_at).format('YYYY-MM-DD, HH:mm:ss') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import LinkageOperatorLookup from "@/library/LinkageOperatorLookup";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    LinkageOperatorLookup
  },
  props: {
    linkageDetail: {
      type: Object,
      default: {}
    },
    operatorID: {
      type: String,
      default: ''
    },
    secondMemberName: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false,
    memberLinkageDetailList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKey: null,
    sortType: null,
    currentPageDetail: 1,
    totalRowDetail: 0,
    linkageType: null,
    getPageSizeDetail: 10,
  }),
  computed: {
    // getPageSizeDetail() {
    //   return this.$store.getters.pageSizeMemberReport;
    // },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.linkageType = this.linkageDetail.linkage_type
      this.getMemberLinkageDetail();
    }
  },
  methods: {
    redirect() {
      this.$emit("backClick");
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getMemberLinkageDetail(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    refresh() {
      this.getMemberLinkageDetail();
    },
    getMemberLinkageDetail: function() {
      let url = config.memberLinkageDetailsUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_id: this.linkageDetail.source_id,
        target_id: this.linkageDetail.target_id,
        linkage_type: this.linkageType,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentPageDetail,
        page_size: this.getPageSizeDetail
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.memberLinkageDetailList = response.data.dt;
                this.totalRowDetail = response.data.dt.length > 0 ? this.memberLinkageDetailList[0]["totalRowDetails"] : 0
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageDetailSize: function(pageSize) {
      // this.$store.dispatch("layout/setPageSizeMemberReport", pageSize);
      this.getPageSizeDetail = pageSize
      this.currentPageDetail = 1;
      this.getMemberLinkageDetail(true);
    },
    changedPageDetail: function(pageNo) {
      this.currentPageDetail = pageNo;
      this.getMemberLinkageDetail();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>